import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { CircularProgress, Typography } from '@mui/material'

const PlaceHolder = ({ label }) => {
  const theme = useTheme()
  return (
    <PlaceHolderView>
      <PlaceHolderContainer>
        <CircularProgress
          size={40}
          color={theme.colors.black}
          sx={{ margin: 'auto' }}
        />
        {label && <Typography variant="body1">{label}</Typography>}
      </PlaceHolderContainer>
    </PlaceHolderView>
  )
}

const PlaceHolderView = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const PlaceHolderContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 0.4rem;
`

export default PlaceHolder
